import { useParams } from "react-router-dom";

export const useEmailTypeId = () => {
  const { emailTypeId } = useParams();

  if (!emailTypeId) {
    throw new Error("Email type ID is required");
  }

  return emailTypeId as string;
};
